import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  TIMELINE: null,
  PAGE: null,
  CONTACT_SEARCH_FILTERS: null
});